'use client';

import RcPagination, { PaginationProps as RcPaginationProps } from 'rc-pagination';
import React, { FC, useEffect, useState } from 'react';

import './styles.scss';

export interface PaginationProps extends RcPaginationProps {}

const Pagination: FC<PaginationProps> = (props) => {
  const { current } = props;
  const [active, setActive] = useState(current || 1);

  // follow the parent when the page changes from outside (link with ?page, back button, new search)
  useEffect(() => {
    setActive(current || 1);
  }, [current]);

  const onPageChange = (page: number, pageSize: number) => {
    setActive(page);
    props.onChange?.(page, pageSize);
  };

  if (props.total! < props.pageSize!) {
    return null;
  }

  return (
    <RcPagination
      {...props}
      current={active}
      onChange={onPageChange}
      prefixCls="ft-pagination"
      jumpNextIcon={<span style={{ fontSize: '1.6rem' }}>...</span>}
      jumpPrevIcon={<span style={{ fontSize: '1.6rem' }}>...</span>}
      nextIcon={
        <div className="ft-pagination-next ft-pagination-arrow">
          {/* <span className="prevNextBtnTxt">{t("PREV")}</span> */}
          <i className="bc-i-arrow-right iconPaginationArrow" />
        </div>
      }
      prevIcon={
        <div className="ft-pagination-prev ft-pagination-arrow">
          <i className="bc-i-arrow-left iconPaginationArrow" />
          {/* <span className="prevNextBtnTxt">{t("NEXT")}</span> */}
        </div>
      }
      showTitle={false}
    />
  );
};

export default Pagination;
